// extracted by mini-css-extract-plugin
export var icon = "_qn-0";